<template>
  <div class="fixed top-0 left-0 w-screen h-screen bg-g0/80 flex justify-center items-center p-10 z-[99999999999]"
    v-if="confirm_data != false">
    <div class="p-5 bg-g1 w-fit max-w-[720px] h-fit rounded-lg shadow-[0_0_20px_10px_#2b2b2b]">
      <div class="w-full text-lg text-center" v-html="confirm_data.message"></div>
      <div class="flex justify-evenly mt-5 flex-wrap">
        <span @click="$root.confirm_data.resolve(false)"
          class="bg-error rounded-full w-[50px] h-[50px] mt-1 sm:mt-0 p-3 flex justify-center items-center sm:mr-1 cursor-pointer hover:opacity-80">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.717 31.717">
            <g transform="translate(-52 -31.8)">
              <g transform="translate(38.2 18)">
                <path
                  d="M40.156,13.8l-10.5,10.5-10.5-10.5L13.8,19.161l10.5,10.5-10.5,10.5,5.361,5.361,10.5-10.5,10.5,10.5,5.361-5.361-10.5-10.5,10.5-10.5Z"
                  transform="translate(0 0)" fill="#fff" />
              </g>
            </g>
          </svg>
        </span>

        <span @click="$root.confirm_data.resolve(true)"
          class="bg-success rounded-full  w-[50px] h-[50px] mt-1 sm:mt-0 p-2 flex justify-center items-center sm:ml-1 cursor-pointer hover:opacity-80">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.403 29.278">
            <g transform="translate(-172.798 -99.861)">
              <g transform="translate(139.798 37.861)">
                <path d="M70.4,67.183l-24.1,24.1L33,77.97l5.183-5.183,8.125,8.125L65.22,62Z" fill="#fff" />
              </g>
            </g>
          </svg>
        </span>
      </div>

    </div>
  </div>
</template>

<script>
import { bindKey, unbindKey } from '@rwh/keystrokes'

export default {
  name: "Confirm",
  components: {},
  props: [
    'confirm_data'
  ],

  setup() {
    return {};
  },
  mounted() {
    bindKey('Enter', () => { this.undind(); $root.confirm_data.resolve(true) })
    bindKey('Backspace', () => { this.undind(); $root.confirm_data.resolve(false) })
    bindKey('Delete', () => { this.undind(); $root.confirm_data.resolve(false) })
  },
  unmounted() {
    this.undind()
  },
  methods: {
    undind() {
      unbindKey('Enter')
      unbindKey('Backspace')
      unbindKey('Delete')
    }
  }
};
</script>
